export interface SeasonPassPriceResponse {
  seasonPassPrice: string; // "1", "2", "3", or "4"
}

// function to get the season pass price from backend
export const getSeasonPassPrice = async (): Promise<string> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/app-config/season-pass-price`;

    // Using native fetch for configuration data (no caching needed)
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // No authorization needed since this endpoint is public
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch season pass price: ${response.status}`);
    }

    const data: SeasonPassPriceResponse = await response.json();
    return data.seasonPassPrice;
  } catch (error) {
    console.error("Error fetching season pass price:", error);
    // Return default value if the request fails
    // This ensures the app doesn't crash if the backend is unavailable
    return "1"; // Default to "1" (Pre-Season)
  }
};
